/**
 * Critically damped smoothing (SmoothDamp) — never lerp for camera motion: lerp is
 * framerate-dependent and has a long tail (camera design C1). State is {value, velocity}.
 */
export interface Damped {
  value: number;
  velocity: number;
}

export const damped = (value = 0): Damped => ({ value, velocity: 0 });

/** Advance one frame toward `target`; `smoothTime` is the ~63% convergence time. */
export function smoothDamp(s: Damped, target: number, smoothTime: number, dt: number): number {
  const omega = 2 / Math.max(smoothTime, 1e-4);
  const x = omega * dt;
  const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
  const change = s.value - target;
  const temp = (s.velocity + omega * change) * dt;
  s.velocity = (s.velocity - omega * temp) * exp;
  s.value = target + (change + temp) * exp;
  return s.value;
}
